import { Injectable } from "@angular/core";

import io from 'socket.io-client';


@Injectable()
export class SocketService {

    socket: any = null;


    createSocket(api_token: string) {
        if (this.socket == null) {
            // GiD0QpP44TPdS5OPrq85jkT2D3DYspYOq9n2JBfE6SvXX5PjYIjuua0ONeIC
            this.socket = io('http://' + window.location.hostname + ':3000?api_token=' + api_token);
        }
    }

    get hasSocket() {
        return this.socket != null;
    }
}